module.exports = __webpack_public_path__ + "img/binding_pc_tab_02.1f4e2e18.png";